import { SectionHeading } from '@/components/InvoiceReportDetailDrawer/parts/SectionHeading';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { JournalInfoTableView } from './Table';

type JournalInfoProps = {
  reportId: string;
  initialOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const JournalInfo: FC<JournalInfoProps> = memo(
  ({ reportId, initialOpen, onToggle }) => {
    const { t } = useTranslation();

    return (
      <SectionHeading
        initialOpen={initialOpen}
        title={t('journal_entry.section_title')}
        onToggle={onToggle}
      >
        <JournalInfoTableView reportId={reportId} />
      </SectionHeading>
    );
  }
);
JournalInfo.displayName = 'AdminInvoiceReportDetailJournalInfo';
